import React from 'react';
import './Blog.css';

import { FaTags, FaUserCircle } from 'react-icons/fa'; // Importing icons for user and category

import { Link } from 'react-router-dom'; // Importing Link for navigation

// Blog Component: Displays an individual blog item
const Blog = (props) => {
  
  // Destructuring props for cleaner access
  const { id, image, date, heading, blog, admin, category } = props;

  return (
    <div className='blog-item' key={id}> {/* Blog Item */}

      {/* Blog Image Section */}
      <div className='image'>
        <img src={image} alt={heading} /> {/* Blog image with alt text */}
        <div className='date'>{date.substring(0, date.indexOf(","))}</div> {/* Extracting and displaying the blog's date */}
      </div>

      {/* Blog Content Section */}
      <div className='content'>

        {/* Blog Title Link: Navigates to the individual blog page */}
        <Link
          to={{
            pathname: '/Blogs/' + heading,
          }}
          state={blog}
          className='main-heading'>
          {heading} {/* Displaying blog title */}
        </Link>

        {/* Blog Details Section (Author & Category) */}
        <div className='details'>
          {/* Blog Author */}
          <h3>
            <FaUserCircle className='icon' /> {/* User icon */}
            <span>By {admin}</span>
          </h3>
          
          {/* Blog Category with Link */}
          <h3>
            <FaTags className='icon' /> {/* Tag icon */}
            <span>
              <Link
                className='category'
                key={blog.id}
                to={`/Blogs/category/${category}`}>
                {category}
              </Link>
            </span>
          </h3>
        </div>

      </div>
      
    </div>
  );
};

export default Blog;